import { Team, Game, createTeamProfileStructuredData } from 'helpers/structuredData';

interface TeamStructuredDataProps {
  team: Team;
  games: Game[];
}

const TeamStructuredData: React.FC<TeamStructuredDataProps> = ({ team, games }) => {
  const jsonLd = createTeamProfileStructuredData(team, games);

  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }} />;
};

export default TeamStructuredData;
